import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { TenantMasterPackage } from '../../../interfaces/masters/tenantMasterPackage';

@Injectable()
export class TenantMasterPackageApi {
  private readonly apiController: string = 'tenantmasterPackage';

    constructor(private api: HttpService) { }

    list(options?: any): Observable<any[]> {
        const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
        //header.append('Content-Type', 'applications/json');
        //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
        //header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.get(this.apiController,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
      }

 
  getById(url: string, options?: any): Observable<TenantMasterPackage> {
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.directGet(url,header);
      }
    
  add(url: string, data: any): Observable<TenantMasterPackage>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.directPost( url, data, header);
      }
      addArray(url:string,data:any):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, header);

  }
   
  update(url: string, data: any):Observable<any>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
      }
    
      delete(url: string):Observable<any>{
        return this.api.directDelete(url);
      }
  
}
